import React from 'react';
import { mockTariffLedger, formatCurrency } from '../../../services/mockData';

const TariffLedger = () => (
  <div className="fade-in">
    <div className="page-header">
      <div className="breadcrumb">Income &amp; Expense Tracker <span>/ Tariff Ledger</span></div>
      <h2>Tariff Ledger Report</h2>
    </div>

    <div className="filter-bar">
      <div className="form-group">
        <label>Select</label>
        <select className="form-control">
          <option>ALL</option>
          <option>Repair Fund</option>
          <option>Water Charges</option>
          <option>Sinking Fund</option>
        </select>
      </div>
      <div className="form-group">
        <label>From Date</label>
        <input type="date" className="form-control" />
      </div>
      <div className="form-group">
        <label>To Date</label>
        <input type="date" className="form-control" />
      </div>
      <div className="form-group" style={{ marginLeft: 'auto', justifyContent: 'flex-end' }}>
        <div className="btn-group">
          <button className="btn btn-primary">🔍 Search</button>
          <button className="btn btn-warning btn-sm">🖨️ Print / Save as PDF</button>
          <button className="btn btn-success btn-sm">📊 Export To Excel</button>
        </div>
      </div>
    </div>

    <div className="card">
      <div className="report-header" style={{ marginBottom: '16px' }}>
        <h3>Vitthal Plaza Co-Op Housing Society LTD</h3>
        <p>Registration Number: TNADO(M/HSG/TC)/25796/YEAR-2023 | dr Sagar(Dombivali)</p>
        <p style={{ fontWeight: '700', marginTop: '6px' }}>
          Tariff Ledger Account Statement — For The Financial Year: 2025-2026 — Dated: 2026-02-01
        </p>
      </div>

      {/* Repair Fund */}
      <div className="section-title" style={{ marginBottom: '10px' }}>Repair Fund</div>
      <div className="table-wrapper" style={{ marginBottom: '24px' }}>
        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Particulars</th>
              <th className="amount">Dr. Amount</th>
              <th className="amount">Cr. Amount</th>
              <th className="amount">Closing</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan={5} style={{ fontStyle: 'italic', color: '#718096', padding: '6px 14px' }}>Opening Balance</td>
            </tr>
            {mockTariffLedger.repairFund.map((r, i) => (
              <tr key={i}>
                <td>{r.date}</td>
                <td>{r.month}</td>
                <td className="amount dr">{r.dr > 0 ? formatCurrency(r.dr) : '0.00'}</td>
                <td className="amount cr">{formatCurrency(r.cr)}</td>
                <td className="amount cr" style={{ fontWeight: '700' }}>{formatCurrency(r.closing)} CR</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Water Charges */}
      <div className="section-title" style={{ marginBottom: '10px' }}>Water Charges</div>
      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Particulars</th>
              <th className="amount">Dr. Amount</th>
              <th className="amount">Cr. Amount</th>
              <th className="amount">Closing</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan={5} style={{ fontStyle: 'italic', color: '#718096', padding: '6px 14px' }}>Opening Balance</td>
            </tr>
            {mockTariffLedger.waterCharges.map((w, i) => (
              <tr key={i}>
                <td>{w.date}</td>
                <td>{w.month}</td>
                <td className="amount dr">{w.dr > 0 ? formatCurrency(w.dr) : '0.00'}</td>
                <td className="amount cr">{formatCurrency(w.cr)}</td>
                <td className="amount cr" style={{ fontWeight: '700' }}>{formatCurrency(w.closing)} CR</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export default TariffLedger;
